import { render, staticRenderFns } from "./AccountApplyList.vue?vue&type=template&id=a65a1c10&"
import script from "./AccountApplyList.vue?vue&type=script&lang=js&"
export * from "./AccountApplyList.vue?vue&type=script&lang=js&"
import style0 from "./AccountApplyList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports